import { axios } from "gather-common-including-video/dist/src/public/axios";
import { debugLogMajorEvent } from "../../DebugLogger";
import { Logger } from "../../Logger";
import { metricsManager as globalsMetricsManager } from "../../Globals";
class ThrottledURLStatusChecker {
    static CHECK_URL_TIMEOUT_MS = 5000;
    static THROTTLE_RATE_MS = 120000;
    static instance = new ThrottledURLStatusChecker();
    _recentlyCheckedURLs = {};
    async check(url) {
        if (url in this._recentlyCheckedURLs)
            return;
        this._recentlyCheckedURLs[url] = true;
        setTimeout(() => delete this._recentlyCheckedURLs[url], ThrottledURLStatusChecker.THROTTLE_RATE_MS);
        try {
            const res = await axios.get(url, {
                timeout: ThrottledURLStatusChecker.CHECK_URL_TIMEOUT_MS,
            });
            if (res.status === 200) {
                const logMessage = `GET ${url} OK`;
                debugLogMajorEvent(logMessage);
            }
            else {
                Logger.warn(`GET ${url} unexpected status ${res.status}`);
                globalsMetricsManager.addMetricReliably("gvc-health-check-error", {
                    serverURL: url,
                    status: res.status,
                });
            }
        }
        catch (error) {
            Logger.warn(`GET ${url} error`, error);
            globalsMetricsManager.addMetricReliably("gvc-health-check-error", {
                serverURL: url,
                error: error instanceof Error ? error.name : "",
                message: error instanceof Error ? error.message : String(error),
            });
        }
    }
}
export default ThrottledURLStatusChecker.instance;
//# sourceMappingURL=ThrottledURLStatusChecker.js.map